import EventsTabs from './components/EventsTabs';
import ApplicationLogoVertical from '../../components/common/ApplicationLogoVertical';
import { getUserPersonalId } from '../../common/EntitiesManagement';
import localize from '../../common/localize';

export default function Events({ myServicesMode = false }) {
  if (myServicesMode && !getUserPersonalId()) {
    return (
      <div
        className="flex flex-col items-center justify-center text-center"
        style={{ minHeight: '80vh', padding: '24px', gap: '16px' }}
      >
        <ApplicationLogoVertical height={120} width={120} />
        <p className="main_text_color" style={{ maxWidth: '420px', fontWeight: 500 }}>
          {localize.my_services_no_personal}
        </p>
      </div>
    );
  }

  return (
    <div>
      <EventsTabs myServicesMode={myServicesMode} />
    </div>
  );
}
